import { useState } from "react";

export function useCopiedBanner() {
  const [visible, setVisible] = useState(false);

  const showBanner = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), 1000);
  };

  const CopiedBanner = () =>
    visible ? (
      <div
        style={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "-120px",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          color: "white",
          padding: "10px 20px",
          borderRadius: "8px",
          fontSize: "10px",
          zIndex: 10000,
        }}
      >
        Email Copied
      </div>
    ) : null;

  return { showBanner, CopiedBanner };
}
